import React from "react";

export const Marquee = () => {
  const phrase = "We Complete For Excellency";
  const items = Array.from({ length: 8 });
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-[#2c1e16]/10 bg-[#f3ebe1] py-8 overflow-hidden"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {items.map((_, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-4xl md:text-6xl text-[#2c1e16]/25 px-10">
              {phrase}
            </span>
            <span className="text-[#c96c31] text-3xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
